"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModuleRegistry = void 0;
var tslib_1 = require("tslib");
var generateGUID_1 = require("../utils/guid/generateGUID");
var ReactModuleContainerErrors_1 = require("./ReactModuleContainerErrors");
var ModuleRegistry = /** @class */ (function () {
    function ModuleRegistry() {
        this.cleanAll();
    }
    ModuleRegistry.prototype.cleanAll = function () {
        this.registeredComponents = {};
        this.registeredMethods = new Map();
        this.eventListeners = {};
        this.modules = {};
    };
    ModuleRegistry.prototype.registerModule = function (globalId, ModuleFactory, args) {
        if (args === void 0) { args = []; }
        if (this.modules[globalId]) {
            throw new Error("A module with id \"" + globalId + "\" is already registered");
        }
        this.modules[globalId] = new (ModuleFactory.bind.apply(ModuleFactory, tslib_1.__spread([void 0], args)))();
    };
    ModuleRegistry.prototype.getModule = function (globalId) {
        return this.modules[globalId];
    };
    ModuleRegistry.prototype.getAllModules = function () {
        var _this = this;
        return Object.keys(this.modules).map(function (moduleId) { return _this.modules[moduleId]; });
    };
    ModuleRegistry.prototype.registerComponent = function (globalId, generator) {
        this.registeredComponents[globalId] = generator;
    };
    ModuleRegistry.prototype.component = function (globalId) {
        var generator = this.registeredComponents[globalId];
        if (!generator) {
            this.notifyListeners('reactModuleContainer.error', new ReactModuleContainerErrors_1.UnregisteredComponentUsedError(globalId));
            return;
        }
        return generator();
    };
    ModuleRegistry.prototype.addListener = function (globalId, callback) {
        var _this = this;
        var callbackKey = "eventListener_" + generateGUID_1.generateGUID();
        this.eventListeners[globalId] = this.eventListeners[globalId] || {};
        this.eventListeners[globalId][callbackKey] = callback;
        return {
            remove: function () {
                if (_this.eventListeners[globalId]) {
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete _this.eventListeners[globalId][callbackKey];
                }
            },
        };
    };
    ModuleRegistry.prototype.notifyListeners = function (globalId) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var listenerCallbacks = this.eventListeners[globalId];
        if (!listenerCallbacks) {
            return;
        }
        Object.values(listenerCallbacks).forEach(function (callback) { return invokeSafely(globalId, callback, args); });
    };
    ModuleRegistry.prototype.registerMethod = function (globalId, generator) {
        this.registeredMethods.set(globalId, generator);
    };
    ModuleRegistry.prototype.invoke = function (methodGlobalId) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var generator = this.registeredMethods.get(methodGlobalId);
        if (!generator) {
            this.notifyListeners('reactModuleContainer.error', new ReactModuleContainerErrors_1.UnregisteredMethodInvokedError(methodGlobalId));
            return;
        }
        var method = generator();
        return method.apply(void 0, tslib_1.__spread(args));
    };
    return ModuleRegistry;
}());
function invokeSafely(globalId, callback, args) {
    try {
        callback.apply(void 0, tslib_1.__spread(args));
    }
    catch (err) {
        moduleRegistry.notifyListeners('reactModuleContainer.error', new ReactModuleContainerErrors_1.ListenerCallbackError(globalId, err));
    }
}
var moduleRegistry;
// to avoid memory leaks in SSR, module registry should be created on demand
exports.getModuleRegistry = function () {
    if (!moduleRegistry) {
        if (typeof window !== 'undefined') {
            // @ts-expect-error
            window.ModuleRegistry = window.ModuleRegistry || new ModuleRegistry();
            // @ts-expect-error
            moduleRegistry = window.ModuleRegistry;
        }
        else {
            moduleRegistry = new ModuleRegistry();
        }
    }
    return moduleRegistry;
};
//# sourceMappingURL=ModuleRegistry.js.map